<template>
    <div class="story-maker-sticker story-maker-sticker-text" :class="{edit : isSelected}" @click="finish">
       
        <!-- <p class="text-finish" @click="()=>finish()">Terminé</p> -->
        <div class="sticker sticker-text"
            :style="{
                textAlign: `${stickerInstance.data.align}`,
            }"
        >
            <p
                :contenteditable="isSelected"
                @input="handlerInput"
                @focus="handlerOnFocus"
                @blur="handlerOnBlur"
                ref="textEditable"
                v-html="models.textFormat"
                spellcheck="false"
                class="textarea"
                :class="`${stickerInstance.data.font} ${stickerInstance.data.align}`"
                :style="{
                    fontSize: `${this.stickerInstance.data.fontSize / 16}em`, //`${0.9375 + ((this.stickerInstance.data.fontSize - 15) * 10)/16 / 10}em`,
                    textAlign: `${stickerInstance.data.align}`,
                    color: stickerInstance.data.background == 'primary' ? secondaryColor : stickerInstance.data.color,
                    backgroundColor: stickerInstance.data.background == 'none' ? '' : stickerInstance.data.background == 'secondary' ? secondaryColor : stickerInstance.data.color,
                    boxShadow: stickerInstance.data.background == 'none' || textEmpty ? '' : `
                        ${stickerInstance.data.background == 'secondary' ? secondaryColor : stickerInstance.data.color} 0.4em 0px 0px 0.28em, 
                        ${stickerInstance.data.background == 'secondary' ? secondaryColor : stickerInstance.data.color} -0.4em 0px 0px 0.28em, 
                        ${stickerInstance.data.background == 'secondary' ? secondaryColor : stickerInstance.data.color} 0px 0px 0px 0.28em
                    `,
                }"
            ></p>
        </div>              

        <div class="container-cursor-size">
            <div class="cursor-size">
                <input 
                    @input="cursorChange"
                    :value="String((stickerInstance.data.fontSize - 15) * 10)"
                    type="range" 
                    min="0" 
                    max="350"
                >
                <svg width="auto" height="auto" viewBox="0 0 80 794" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M40 793L1 1H79L40 793Z" fill="#CBCBCD" stroke="#CBCBCD" stroke-linejoin="round"/>
                </svg>
            </div>
        </div>
        
        <div class="container-action">
            <div class="list-option">
                <div v-if="actionSelected == 'font'" class="list-option-text hide-scrollbar" @wheel="handleHorizontalScroll">
                    <div class="texts">
                        <div 
                            v-for="font in ['modern','classic','signature','editor','poster','bubble','deco','squeeze','typewriter','strong','meme','elegant','directional','literature']"
                            :key="font"
                            :class="['text', font, `${font}-font`, { active: stickerInstance.data.font === `${font}-font` }]" 
                            @click="changeFont(`${font}-font`)
                        ">
                            {{ font.charAt(0).toUpperCase() + font.slice(1) }}
                        </div>
                    </div>
                </div>

                 <div v-else-if="actionSelected == 'color'" class="list-option-color">
                    <div class="pipette">
                        <div class="icon" :style="{backgroundColor: pickerColors.hex}" @click="()=>{ stickerInstance.data.color = pickerColors.hex; colorPickerShow = true; showPipette = true}">

                        <div class="picker-color" v-if="colorPickerShow" @mouseleave="colorPickerShow = false" @mousedown="showPipette = false">
                            <div class="icon-pipette" v-if="eyeDropperIsAccess && showPipette" @mousedown.stop @click.stop="startEyeDropper"></div>
                            <chrome-picker :value="pickerColors" @input="updateFromPicker"/>
                        </div>
                        
                    </div></div>
                    <div class="color-carousel">
                        <carousel :perPage="1" :adjustableHeight="true" :centerMode="true" @pageChange="()=>{}" >
                            <Slide v-for="(colors,index) in [['#FFFFFF','#000000','#4397EF','#70C04F','#F6CB5B','#F08C34','#EA4857','#D12D69','#B100C0'],['#EA3323','#ED858E','#F7D0D1','#FADAB4','#F5C281','#D18E47','#99643A','#432324','#1D4A29'],['#262626','#363636','#555555','#737373','#999999','#B2B2B2','#C7C7C7','#DBDBDB','#EFEFEF']]" :key="index">
                                <div v-for="colorHexa in colors" class="color" :style="`background-color:${colorHexa}`" @click="()=>{stickerInstance.data.color = colorHexa; pickerColors.hex = colorHexa}"></div>
                            </Slide>
                        </carousel>
                            
                    </div>
                 </div>
            </div>
            <div class="list-action">
                <div class="action font" :class="{active : actionSelected == 'font'}" @click="actionSelected = 'font'">
                    <div class="icon"></div>
                </div>
                <div class="action color" :class="{active : actionSelected == 'color'}" @click="actionSelected = 'color'">
                    <div class="icon"></div>
                </div>
                <div class="action align" :class="`${stickerInstance.data.align}`" @click="stickerInstance.data.align = {'center':'start','start':'end','end':'center'}[stickerInstance.data.align]">
                    <div class="icon"></div>
                </div>
                <div class="action background" :class="`${stickerInstance.data.background}`" @click="stickerInstance.data.background = {'secondary':'primary','primary':'none','none':'secondary'}[stickerInstance.data.background]">
                    <div class="icon"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { EventBus } from '@/event-bus';
import store from '@/store/index.js';
import { Carousel, Slide } from 'vue-carousel';
import { Chrome } from 'vue-color'
import { getLuminanceColor, adjustColorBrightness, hex2rgb, increase_brightness } from '@/utils/Color.js'
import minxinBot from '@/components/mixins/Bots.vue'

const fakeIdMention = 1234567890

export default {

    components: {
        Carousel,
        Slide,
        'chrome-picker': Chrome,
    },

    mixins: [minxinBot],

    props: {
        id: [Number, String],
        isSelected: Boolean,
        stickerInstance: {
            type: Object,
            required: true
        }
    },
    
    data() {
        return {
            actionSelected: 'font',
            models: {
                textFormat: '',
                textDefault: '',
            },
            //cursorPosition: null,
            timeoutFinish: null,
            colorPickerShow: false,

            pickerColors: {
				hex: '#000000',
			},
            
            eyeDropperIsAccess : false,
            showPipette : true,
            textEmpty : true,

            cursor : {
                nodeIndex: null,
                startOffset: null,
                endOffset:null,

                previousCursor: {
                    nodeIndex: null,
                    startOffset: null,
                    endOffset:null
                }
            },

            idMentionSelected: null,

            keyAtPressedEvent : {
                flag: false,
                indexAt: null
            },

            isFocused: false
        }
    },

    mounted () {
        this.eyeDropperIsAccess = !!window.EyeDropper
        this.isEmpty = this.stickerInstance.data.text.length == 0
        
        this.$nextTick(()=> {
            if(this.isSelected) this.focusAtEnd()
        })
        
    },
    
    methods: {

    
        cursorChange(e) {
            this.stickerInstance.data.fontSize = 15 + parseInt(e.target.value) / 10
        },

        finish(event) {

            if(this.isSelected) {

                if (!this.isFocused) this.focusAtEnd()
                if (this.keyAtPressedEvent.flag) {
                    this.closeSelectMention()
                }

                if (event.target.classList.contains('story-maker-sticker') || event.target.classList.contains('text-finish')) {
                    if (!this.$refs['textEditable']?.innerText?.length) {
                        this.$emit('deleteSticker');
                    }
                    this.$emit('unselect')
                }
            } 
        },
        updateFromPicker(value) {
            this.pickerColors = {
                hex: value.hex
            }
            this.stickerInstance.data.color = value.hex
        },

        startEyeDropper() {
            if (!window.EyeDropper) return
            this.colorPickerShow = false
            const eyeDropper = new EyeDropper();

            eyeDropper.open().then((result) => {
                this.stickerInstance.data.color = result.sRGBHex
                this.pickerColors = {
                    hex: result.sRGBHex
                }
            })
        },

        changeFont(name) {
            this.stickerInstance.data.font = name
            this.focusAtEnd()
        },
        
        focusAtEnd() {
            try {
                const element = this.$refs[`textEditable`]
                const range = document.createRange();
                const selection = window.getSelection();

                range.selectNodeContents(element);
                range.collapse(false);

                selection.removeAllRanges();
                selection.addRange(range);

                element.focus();
            } catch (error) {
                
            }
           
        },
        
        /////// INPUT EVENT ///////
        getTextarea() {
            return this.$refs[`textEditable`]
        },

        handlerInput(e) {
            this.updateCursorPosition()
            this.models.textFormat = e.target.innerHTML
            this.$nextTick(() => {
                this.restoreCursorPosition()
                this.setTextareaContentValue(e.target.innerHTML, e)
            });
        },

        handlerOnFocus(e) {
            this.isFocused = true;
        },
        
        handlerOnBlur(e) {
            // Supprime les `<br>` en fin de chaîne
            this.models.textFormat = this.models.textFormat.replace(/(<br\s*\/?>)+$/g, '');
            this.setTextareaContentValue(this.models.textFormat, e)
            this.isFocused = false;
        },

        updateCursorPosition() {
           
           const selection = window.getSelection();

           if (selection.rangeCount > 0) {

               try{
                   const range = selection.getRangeAt(0);
                   let startContainer = range.startContainer;
                   let nodeIndex = -1
                  
                   if (startContainer instanceof Text) {
                       const parentNode = startContainer.parentNode.closest('.textarea');
                       while (startContainer.parentNode !== parentNode) {
                           startContainer = startContainer.parentNode;
                       }
                       nodeIndex = Array.from(parentNode.childNodes).indexOf(startContainer);
                   }

                   if (this.cursor.startOffset !== range.startOffset || this.cursor.nodeIndex !== nodeIndex) {
                       this.cursor = {
                           nodeIndex: nodeIndex,
                           startOffset: range.startOffset,
                           endOffset: range.endOffset,

                           previousCursor: {
                               nodeIndex: this.cursor.nodeIndex,
                               startOffset: this.cursor.startOffset,
                               endOffset: this.cursor.endOffset
                           }
                       };
                   }
               } catch (error) {
                   this.cursor = {
                       nodeIndex: this.cursor.nodeIndex -1,
                       startOffset: 0,
                       endOffset: 0,

                       previousCursor: {
                           nodeIndex: this.cursor.nodeIndex,
                           startOffset: this.cursor.startOffset,
                           endOffset: this.cursor.endOffset
                       }
                   };
               }
               
           }

           //console.log("updateCursorPosition",this.cursor.nodeIndex,this.cursor.startOffset,this.cursor.endOffset)
        },
       
        restoreCursorPosition(restorePreviousCursor = false) {

           this.getTextarea().focus();

           if (restorePreviousCursor && (!this.cursor.previousCursor || !this.cursor.previousCursor.startOffset)) return;
           if (!restorePreviousCursor && (!this.cursor.startOffset)) return;


           const cursor = restorePreviousCursor ? this.cursor.previousCursor : this.cursor
          
           let node = cursor.nodeIndex >= 0 ? this.getTextarea().childNodes[cursor.nodeIndex] : this.getTextarea()

           if (cursor.nodeIndex >= 0) {
               while (node.childNodes && node.childNodes[0]) {
                   node = node.childNodes[0]
               }
           }
               
           const selection = window.getSelection();
           selection.removeAllRanges();

           const range = document.createRange();

           range.setStart(node, cursor.startOffset);
      
           range.collapse(true);
           selection.addRange(range);
           
        },

        setTextareaContentValue(innerHTML, e) {

            function escapeSpecialChars(str) {
                // Remplacer les caractères échappés par leurs équivalents littéraux
                return str
                .replace(/\\/g, '\\\\')   // Backslash '\\'
                .replace(/\n/g, '\\n')     // Newline '\n'
                .replace(/\t/g, '\\t')     // Tab '\t'
                .replace(/\r/g, '\\r')     // Carriage return '\r'
                .replace(/\f/g, '\\f')     // Form feed '\f'
                .replace(/\v/g, '\\v')    // Vertical tab '\v'
                .replace(/ /g, '&nbsp;')  // Space ' ' -> '&nbsp;'
                .replaceAll(" ", '&nbsp;')
                .replace(/\u00A0/g, "&nbsp;");
            }

            const div = document.createElement('div');
            div.innerHTML = innerHTML.replace(/<br>/g, '\n');

            div.querySelectorAll('.tag-mention').forEach(element => {
                element.innerHTML = `@${element.getAttribute("idmention")}`
            });

            let innerText = escapeSpecialChars(div.innerText)

            //detecter le debut d'une mention
            if (e && e.data && e.data == '@') {
                const currentValue = this.stickerInstance.data.text
                const newValue = innerText
                const position = newValue.split('').findIndex((char, index) => (currentValue[index] !== char));

                this.idMentionSelected = (new Date).getTime()

                this.keyAtPressedEvent = {
                    flag: true,
                    indexAt: position
                }

                this.$nextTick(() => {
                    EventBus.$on('eventSearchFromSelectMention', this.searchMention);
                    EventBus.$on('eventClickSelectMention', this.addMention);
                    EventBus.$on('eventCloseSelectMention', this.closeSelectMention);
         
                    EventBus.$emit("postCreatorAddMode", "addMentionMode",{ 
                        mention : {
                            textDefault : '',
                            mention : {}
                        },
                        idMention : fakeIdMention,
                    });

                })
            }

            this.textEmpty = innerText.length == 0  
            this.stickerInstance.data.text = innerText
        },

        updateHtmlTextarea() {
            console.log('texttest updateHtmlTextarea')
            //important
            //quand this.getTextareaRef().textareaValue change le composant executera setTextareaContentValue
          
            let newValue = this.stickerInstance.data.text.replace(/@(\d{13})/g, (match, id) => {
                console.log('texttest updateHtmlTextarea', id, this.stickerInstance.getMention(id))
                const mention = this.stickerInstance.getMention(id);

                if (mention && mention.mention.instagram) {
                    return `<span class="tag-mention no-select" idmention="${id}" contenteditable="false" spellcheck="false">@${mention.mention.instagram.id.trim()}</span>`
                }
                return match;
            }).replaceAll('&nbsp;'," ") //.replace(/\\n/g, '<br>')

            //replaceAll('&nbsp;'," ") pour break-word
            
            if (this.getTextarea().innerHTML !== newValue) {
                
                this.$set(this.models, 'textFormat', newValue);

                // if (focus) {
                //     this.$nextTick(() => {
                //         this.restoreCursorPosition(restorePreviousCursor)
                //     })
                // }
            }
        },

        async searchMention(value, network, idEvent, idMention) {
            console.log("searchMention",value, network, idEvent, idMention)
            if (this.isSelected && idMention == fakeIdMention && this.keyAtPressedEvent.flag && network == 'instagram') {
                let isUrl = false
                let page = this.pagesSelected.find(p => p.network == 'instagram' && p.story_config && p.story_config.created) || this.pagesSelected.find(p => p.network == 'instagram' && p.bot_status)

                let result = []
                if (page && value) {
                    result = (await this.getMentionsByApi(page.id, value, isUrl)).mentions
                }
                EventBus.$emit("resultSearchFromSelectMention", result, idEvent)
            }
        },

        addMention(network, person, idMention) {
            console.log("addMention",network, person, idMention)
            EventBus.$emit("postCreatorRemoveMode");
            EventBus.$off('eventClickSelectMention', this.addMention);
            EventBus.$off('eventSearchFromSelectMention', this.searchMention);
            EventBus.$off('eventCloseSelectMention', this.closeSelectMention);


            if (this.isSelected && idMention == fakeIdMention && this.keyAtPressedEvent.flag) {

                if (person) {
    
                    const mention = {
                        mention : {
                            'instagram' : person
                        },
                        textDefault : ''
                    }

                    this.stickerInstance.addMention(this.idMentionSelected, mention)
                    console.log("addMention", this.idMentionSelected)

                    const position = this.keyAtPressedEvent.indexAt
                    let startText = this.stickerInstance.data.text.slice(0,position)
                    let endText = this.stickerInstance.data.text.slice(position+1)
                    this.stickerInstance.data.text = startText + `@${this.idMentionSelected}` + (endText.replaceAll('\n','').replaceAll('\\n','').length ? endText : '&nbsp;'+endText);
                    this.$nextTick(() => {
                        this.updateHtmlTextarea()
                    })
                }
               
               
              
                this.$set(this.keyAtPressedEvent, 'flag', false)
                
            }
         
        },

        closeSelectMention() {
            EventBus.$off('eventClickSelectMention', this.addMention);
            EventBus.$off('eventSearchFromSelectMention', this.searchMention);
            EventBus.$off('eventCloseSelectMention', this.closeSelectMention);
            this.$set(this.keyAtPressedEvent, 'flag', false)
            this.idMentionSelected = null
            EventBus.$emit("postCreatorRemoveMode");
        },

        handleHorizontalScroll(event) {
            if (event.deltaX == 0) {
                event.preventDefault();
                const scrollContainer = event.currentTarget;
                scrollContainer.scrollLeft += event.deltaY;
            }
        }
                   

    },

    computed: {
        secondaryColor() {
            const rbgColorObject = hex2rgb(this.stickerInstance.data.color)

            if (rbgColorObject.r == 255 && rbgColorObject.g == 255 && rbgColorObject.b == 255) return '#000000'
            if (rbgColorObject.r == 0 && rbgColorObject.g == 0 && rbgColorObject.b == 0) return '#FFFFFF'

            return getLuminanceColor(...Object.values(rbgColorObject)) > 0.78 ? 
                increase_brightness(...adjustColorBrightness(...Object.values(rbgColorObject),0.1),10)
                : increase_brightness(...Object.values(rbgColorObject), 80)
        },

        allPages() {
            return this.$store.getters['selectPage/selectPageAllPages'];
        },
        pagesSelected() {
            return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
        },
    },

    watch: {
        isSelected: {
            handler(newValue) {
       
                if(newValue) {
                    this.focusAtEnd()

                
                }else{
                    EventBus.$off('eventClickSelectMention', this.addMention);
                    EventBus.$off('eventSearchFromSelectMention', this.searchMention);
                    EventBus.$off('eventCloseSelectMention', this.closeSelectMention);
                }

                
            },
            immediate: true
        },
        "stickerInstance.data.text": {
            handler(newValue) {
                this.models.textDefault = newValue
                if (newValue) this.textEmpty = false
                this.$nextTick(() => {
                    this.updateHtmlTextarea()
                })
            },
            immediate: true
        },
    },

    beforeDestroy () {
        EventBus.$off('eventSearchFromSelectMention', this.searchMention);
        EventBus.$off('eventClickSelectMention', this.addMention);
        EventBus.$off('eventCloseSelectMention', this.closeSelectMention);
    },

    
}
</script>
